import { Component, Inject, OnInit } from '@angular/core';
import { UsuarioService } from 'src/app/data-access/usuario.service'
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { config } from 'src/app/data-access/config';
import { DOCUMENT } from '@angular/common';
import { AuthService } from 'src/app/data-access/auth.service';
import Swal from 'sweetalert2';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styles: []
})
export class InicioComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  ngOnInit() {
    this.spinner.show();
    let usuarioToken = '';
    window.addEventListener('message', (event) => {
      //if (event.origin == 'http://localhost:4200') {
      //if (event.origin == 'https://espaciosdes.ibero.mx') {  
      //if (event.origin == 'https://espaciospru.ibero.mx') {  
      if (event.origin == 'https://espacios.ibero.mx') {  
        if (event.data.type === 'jwtToken') {
          usuarioToken = event.data.token;
          this.activatedRoute.params.subscribe(params => {
            let usuarioDatos = params['id'];
            
            if (usuarioDatos == undefined) {
              this.document.location.href = config.webAppUrl;
            }
            else {
              let usuario = {
                idTipoUsuario: 0,
                cuenta: '',
                digito: '',
                token: '',
                nombre: '',
                apPat: '',
                apMat: '',
                email: '',
                claveDepartamento: 0,
                departamento: '',
                claveCoordinacion: 0,
                coordinacion: '',
                roles: '',
                estatus: true,
                dataURL: ''
              };
    
              usuario.dataURL = usuarioDatos;
              this.usuarioService.validaCuenta(usuario).toPromise()
                .then(data => {
                  let user = data;
                  user.token = usuarioToken;
                  if(!user.estatus){
                    this.router.navigate(['/inactivo']);
                    this.spinner.hide();
                    return true;
                  }
                  this.usuarioService.addUser(user);
                  localStorage.setItem('valido', '1');
                  this.spinner.hide();
                  this.authService.verifyExpirationTime()
    
                  let isAdmin = this.usuarioService.adm();
                  (isAdmin ?  this.router.navigate(['/menu-admin']) :   this.router.navigate(['/menu']))
                  
                  if (localStorage.getItem('fullNameUndefined') == '1') {
                    localStorage.setItem('fullNameUndefined', '0');
                  }
                }, error => {
                  console.log(error)
                })
            }
          });
        }else{
          Swal.fire({
            title: "Error",
            text: "Error de autenticación",
            icon: "error"
          });
        }
      } 
    });
    setTimeout(() => {
      if (usuarioToken == '') {
          this.toastr.warning("Error de autenticación");
          setTimeout(() => {
            window.close();
          },2000);
      }
    },10000);
      
  }

}
